import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto my-12 px-4 py-6 bg-white shadow-lg rounded-lg">
        <header className="text-center mb-8">
          <h1 className="text-3xl font-semibold text-gray-900">Privacy Policy for "Wait, When's Your Birthday"</h1>
          <p className="text-sm text-gray-600">Last Updated: January 29, 2025</p>
        </header>

        <section className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-blue-600">1. Introduction</h2>
            <p>At <strong>"Wait, When's Your Birthday" (WWYB)</strong>, we prioritize the privacy of our users. This Privacy Policy outlines the types of information we collect, how we use it, and how we protect your personal data.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">2. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li><strong>Personal Information:</strong> Name, email address, and birthdate.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our platform, such as device information, IP address, browser type, and session activity.</li>
              <li><strong>Content Data:</strong> Birthdates, profile pictures, and any other information you voluntarily provide when using the platform.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li>Provide and improve our services.</li>
              <li>Connect you with friends and track important birthdays.</li>
              <li>Send you updates, notifications, and other communications related to the service.</li>
              <li>Respond to your inquiries and provide customer support.</li>
              <li>Analyze usage patterns to improve the user experience.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">4. Sharing Your Information</h2>
            <p>We do not sell or share your personal information with third parties for marketing purposes. However, we may share information with trusted third-party service providers who assist in operating our platform, such as:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li>Service providers that help process payments.</li>
              <li>Hosting providers and database management services.</li>
              <li>Other service providers who assist with analytics and marketing.</li>
            </ul>
            <p>We may also share information to comply with legal obligations or protect the rights and safety of WWYB, our users, and the public.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">5. Data Security</h2>
            <p>We use industry-standard security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. However, please note that no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">6. Your Data Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li>Access the personal information we hold about you.</li>
              <li>Request corrections or updates to inaccurate information.</li>
              <li>Request the deletion of your account and data (subject to legal obligations).</li>
              <li>Withdraw your consent for data processing, where applicable.</li>
            </ul>
            <p>To exercise any of these rights, please contact us at <a href="mailto:support@waitwhensyourbirthday.com" className="text-blue-500 hover:underline">support@waitwhensyourbirthday.com</a>.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">7. Cookies and Tracking Technologies</h2>
            <p>We use cookies and similar technologies to collect usage data and enhance your experience on our platform. Cookies help us remember your preferences and improve functionality. You can control cookie settings through your browser, but disabling cookies may affect the performance of the platform.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">8. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time to reflect changes in our practices. We will notify you of significant updates by posting a notice on our platform or sending an email. Please review the policy periodically for any changes.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">9. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
            <p className="text-blue-500">Email: <a href="mailto:support@waitwhensyourbirthday.com">support@waitwhensyourbirthday.com</a></p>
          </div>
        </section>

        <footer className="mt-12 text-center text-sm text-gray-600">
          <p>By using or accessing WWYB, you agree to this Privacy Policy.</p>
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
